<template>
  <div>
    <el-dialog title="收纳服务商合同" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
      <el-form :inline="true" ref="addForm" :model="reqCreate" label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="签署日期" prop="qsrq">
              <el-date-picker v-model="reqCreate.qsrq" style="width:240px" type="date" placeholder="请选择合同签署日期"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="签署公司（乙方）" prop="signSealId" class="item">
          <el-select v-model="reqCreate.signSealId" style="width:620px" @change="selectJms" clearable
            placeholder="请选择签署公司（乙方" filterable>
            <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系地址（乙方）" prop="yaddr" class="nian1">
          <el-input v-model="reqCreate.yaddr" style="width:620px" clearable show-word-limit placeholder="请输入联系地址（乙方）"></el-input>
        </el-form-item>

        <el-form-item label="联系人（乙方）" prop="yname" class="nian">
          <el-input v-model="reqCreate.yname" style="width:255px" clearable show-word-limit placeholder="请输入联系人（乙方）"></el-input>
        </el-form-item>

        <el-form-item label="联系电话（乙方）" prop="yphone" class="nian1">
          <el-input v-model="reqCreate.yphone" style="width:255px" maxlength="11" clearable show-word-limit
            placeholder="请输入联系电话（乙方）"></el-input>
        </el-form-item>

        <el-form-item label="电子邮箱（乙方）" prop="yemail" class="nian1">
          <el-input v-model="reqCreate.yemail" style="width:255px" show-word-limit placeholder="请输入电子邮箱（乙方）" clearable></el-input>
        </el-form-item>

        <el-form-item label="微信（乙方）" prop="ywx" class="nian">
          <el-input v-model="reqCreate.ywx" style="width:255px" show-word-limit  placeholder="请输入微信（乙方）" clearable></el-input>
        </el-form-item> 


        <el-form-item label="合作开始时间" prop="startDate" class="nian">
          <el-date-picker v-model="reqCreate.startDate" style="width:255px" type="datetime" placeholder="请选择合作开始时间"
            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-form-item label="合作截止时间" prop="endDate" class="nian">
          <el-date-picker v-model="reqCreate.endDate" style="width:255px" type="date" placeholder="请选择合作截止时间"
            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-row>
          <el-form-item label="合作商户名" prop="yhName">
            <el-input v-model="reqCreate.yhName" style="width:255px" clearable show-word-limit
              placeholder="请输入合作费及支付的户名"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="yhNum">
            <el-input v-model="reqCreate.yhNum" style="width:255px" clearable show-word-limit
              placeholder="请输入账户信息"></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="yh">
            <el-input v-model="reqCreate.yh" style="width:620px" clearable show-word-limit
              placeholder="请输入开户行信息"></el-input>
          </el-form-item>

          <el-form-item label="保证金" prop="money">
            <el-input v-model="reqCreate.money" style="width:255px" type="number" clearable show-word-limit
              placeholder="请输入保证金额">
              <template slot="append">元</template></el-input>
          </el-form-item>


        </el-row>
        <el-form-item label="举报联系电话" prop="jbPhone">
          <el-input v-model="reqCreate.jbPhone" style="width:255px" maxlength="11" clearable show-word-limit
            placeholder="请输入乙方举报方式-联系电话"></el-input>
        </el-form-item>
        <el-form-item label="举报联系邮箱" prop="jbEmail">
          <el-input v-model="reqCreate.jbEmail" style="width:255px" clearable show-word-limit
            placeholder="请输入乙方举报方式-联系邮箱"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jcxy = false">取消</el-button>
        <el-button type="primary" @click="yulan()">预览合同</el-button>
      </span>
    </el-dialog>

    <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
      <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
        style="width:870px;height:800px"></iframe>

      <span slot="footer" class="dialog-footer">
        <el-button @click="PDFVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
  data() {
    return {
      id: null,
      jcxy: false,
      PDFVisible: false,
      contractUrl: null,
      allJMSList: [],
      rules: {
        signSealId: [{ required: true, message: "请选择签署公司", trigger: "blur" }],
        yphone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        xinyongdaima: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
        yaddr: [{ required: true, message: "请输入乙方联系地址", trigger: "blur" }],
        yemail: [{ required: true, message: "请输入乙方联系邮箱", trigger: "blur" }],
        yname: [{ required: true, message: "请输入乙方联系人", trigger: "blur" }],
        ywx: [{ required: true, message: "请输入乙方微信", trigger: "blur" }],
        qsrq: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],
        startDate: [{ required: true, message: "请选择合作开始日期", trigger: "change" }],
        endDate: [{ required: true, message: "请选择合作截止日期", trigger: "change" }],
      },
      addField: {},
      singList: [],
      choosePerson: {}, //下拉框所选人
      reqCreate: {
        htrq: '',

        "address": "",
        "collectAccount": "",
        "collectBankName": "",
        "collectUserName": "",
        "contractFileId": "",
        "contractNo": "",
        "createTime": "",
        "createUserId": '',
        "createUserName": "",
        dateEnd: "",
        dateStart: "",
        "feeDate": "",
        "fraId": '',
        "fraName": "",
        "id": '',
        "idCard": "",
        "jsonData": "",
        "processId": "",
        "remark": "",
        "signName": "",
        "signSealId": '',
        "state": '',
        "storeNumber": '',
        "tel": "",
        "templateNo": "",
        "type": '',
        "jaddr": '',
        "jname": '',
        "jphone": '',
        "jemail": '',
        "jwx": "",
        "ysignSealId": '',
        "yaddr": '',
        "yname": '',
        "yphone": '',
        "yemail": '',
        "ywx": '',
        "startDate": '',
        "endDate": '',
        "yhName": '',
        "yhNum": '',
        "yh": '',
        "money": '',
        "jbPhone": '',
        "jbEmail": '',
        "jQyName": '',
        "jQydb": '',
        "jQyDate": '',
        "yQyName": '',
        "yQydb": '',
        "yQyDate": '',
        "yeardate": '',
        "dateMonth": '',
        "dateDay": '',
        "addr": '',
        "qsrq": ''


      }
    };
  },
  methods: {
    showDetail() {
      this.getAllJMS();
      this.jcxy = true;

      this.reqCreate = {
        htrq: '',
        "address": "",
        "collectAccount": "",
        "collectBankName": "",
        "collectUserName": "",
        "contractFileId": "",
        "contractNo": "",
        "createTime": "",
        "createUserId": '',
        "createUserName": "",
        dateEnd: "",
        dateStart: "",
        "feeDate": "",
        "fraId": '',
        "fraName": "",
        "id": '',
        "idCard": "",
        "jsonData": "",
        "processId": "",
        "remark": "",
        "signName": "",
        "signSealId": '',
        "state": '',
        "storeNumber": '',
        "tel": "",
        "templateNo": "",
        "type": '',

        mingcheng: '',
        nashuihao: '',
        dizhidianhua: '',
        kaihuhangzhanghao: '',
        "jaddr": '',
        "jname": '',
        "jphone": '',
        "jemail": '',
        "jwx": "",
        "ysignSealId": '',
        "yaddr": '',
        "yname": '',
        "yphone": '',
        "yemail": '',
        "ywx": '',
        "startDate": '',
        "endDate": '',
        "yhName": '',
        "yhNum": '',
        "yh": '',
        "money": '',
        "jbPhone": '',
        "jbEmail": '',
        "jQyName": '',
        "jQydb": '',
        "jQyDate": '',
        "yQyName": '',
        "yQydb": '',
        "yQyDate": '',
        "yeardate": '',
        "dateMonth": '',
        "dateDay": '',
        "addr": '',
        "qsrq": ''
      };

    },
    selectJms(id) {
      if (id == null || id == '') {
        this.choosePerson = {};
        this.reqCreate.fraId = "";
        this.reqCreate.yphone = "";
        this.reqCreate.yaddr = "";
      }
      if (id != null) {
        let ren = {};
        this.allJMSList.forEach(e => {
          if (e.id == id) {
            ren = e;
          }
        })
        this.choosePerson = ren;
        console.log("联系人" + ren)
        this.reqCreate.fraId = ren.franchiseeId;
        this.reqCreate.yphone = ren.tel;
        console.log(ren);
        this.reqCreate.yaddr = ren.address;
      }
    },
    checkFm() {

      if (this.reqCreate.signSealId == null || this.reqCreate.signSealId == '') {
        this.$message.error('请选择签署公司（乙方）');
        return false;
      }
      console.log("长度：" + this.reqCreate.jphone.length);
      // if (this.reqCreate.jphone == null || this.reqCreate.jphone == '' || this.reqCreate.jphone.length != 11) {
      //   this.$message.error('请输入联系电话，或输入正确的电话号码（甲方）');
      //   return false;
      // }
      if (this.reqCreate.yphone == null || this.reqCreate.yphone == '' || this.reqCreate.yphone.length != 11) {
        this.$message.error('请输入联系电话，或输入正确的电话号码（已方）');
        return false;
      }


      /*  if (this.reqCreate.addr == null || this.reqCreate.addr == '') {
          this.$message.error('请输入签署地址');
          return false;
        }*/

      if (this.reqCreate.qsrq == null || this.reqCreate.qsrq == '') {
        this.$message.error('请输入签署日期');
        return false;
      }
      // if (this.reqCreate.jaddr == null || this.reqCreate.jaddr == '') {
      //   this.$message.error('请输入（甲方）联系地址');
      //   return false;
      // }

      if (this.reqCreate.yaddr == null || this.reqCreate.yaddr == '') {
        this.$message.error('请输入（乙方）联系地址');
        return false;
      }
      if (this.reqCreate.yemail == null || this.reqCreate.yemail == '') {
        this.$message.error('请输入（乙方）电子邮箱');
        return false;
      }
      if (this.reqCreate.yname == null || this.reqCreate.yname == '') {
        this.$message.error('请输入（乙方）联系人');
        return false;
      }

      if (this.reqCreate.ywx == null || this.reqCreate.ywx == '') {
        this.$message.error('请输入（乙方）微信');
        return false;
      }
      if (this.reqCreate.startDate == null || this.reqCreate.startDate == '') {
        this.$message.error('请选择合作开始时间');
        return false;
      }

      if (this.reqCreate.endDate == null || this.reqCreate.endDate == '') {
        this.$message.error('请选择合作结束时间');
        return false;
      }

      // if (this.reqCreate.yhName == null || this.reqCreate.yhName == '') {
      //   this.$message.error('请输入户名');
      //   return false;
      // }
      // if (this.reqCreate.yh == null || this.reqCreate.yh == '') {
      //   this.$message.error('请输入开户行');
      //   return false;
      // }
      // if (this.reqCreate.yhNum == null || this.reqCreate.yhNum == '') {
      //   this.$message.error('请输入账号');
      //   return false;
      // }
      // if (this.reqCreate.money == null || this.reqCreate.money == '') {
      //   this.$message.error('请输入保证金');
      //   return false;
      // }
      // if (this.reqCreate.jbPhone == null || this.reqCreate.jbPhone == '') {
      //   this.$message.error('请输入举报联系电话');
      //   return false;
      // }
      // if (this.reqCreate.jbEmail == null || this.reqCreate.jbEmail == '') {
      //   this.$message.error('请输入举报联系邮箱');
      //   return false;
      // }
      if (this.reqCreate.jbPhone != null && this.reqCreate.jbPhone != '' && this.reqCreate.jbPhone.length != 11) {
        this.$message.error('请输入正确的(乙方举报方式)联系电话');
        return false;
      }
      return true;
    },
    fillTemplate() {
      let addField = {
        fraName: this.choosePerson.companyName,
        jaddr: this.reqCreate.jaddr,
        jphone: this.reqCreate.jphone,
        jname: this.reqCreate.jname,
        jemail: this.reqCreate.jemail,
        jwx: this.reqCreate.jwx,

        yaddr: this.reqCreate.yaddr,
        yphone: this.reqCreate.yphone,
        yname: this.reqCreate.yname,
        yemail: this.reqCreate.yemail,
        ywx: this.reqCreate.ywx,
        startYear: this.reqCreate.startDate.substring(0, 4),
        startMonth: this.reqCreate.startDate.substring(5, 7) * 1,
        startDay: this.reqCreate.startDate.substring(8, 10) * 1,
        endYear: this.reqCreate.endDate.substring(0, 4),
        endMonth: this.reqCreate.endDate.substring(5, 7) * 1,
        endDay: this.reqCreate.endDate.substring(8, 10) * 1,
        // collectUserName: this.reqCreate.collectUserName,
        // collectAccount: this.reqCreate.collectAccount,
        // collectBankName: this.reqCreate.collectBankName,
        yeardate: this.reqCreate.qsrq.substring(0, 4),
        dateMonth: this.reqCreate.qsrq.substring(5, 7) * 1,
        dateDay: this.reqCreate.qsrq.substring(8, 10) * 1,
        addr: this.reqCreate.addr,
        yhName: this.reqCreate.yhName,
        yhNum: this.reqCreate.yhNum,
        yh: this.reqCreate.yh,
        money: this.reqCreate.money,
        jbPhone: this.reqCreate.jbPhone,
        jbEmail: this.reqCreate.jbEmail,
        jQyDate: this.reqCreate.qsrq,
        yQyDate: this.reqCreate.qsrq,
        // yi_month: this.reqCreate.htrq.substring(5, 7) * 1,
        // yi_day: this.reqCreate.htrq.substring(8, 10) * 1,
        //
        // mingcheng:this.reqCreate.mingcheng,
        // nashuihao:this.reqCreate.nashuihao,
        // dizhidianhua:this.reqCreate.dizhidianhua,
        // kaihuhangzhanghao:this.reqCreate.kaihuhangzhanghao,
        //
        // zhiding_tel:this.reqCreate.tel,
        // zhidingren:this.choosePerson.faren,

        jia: '',
        yi: '',
        Contract_no: ''
      };
      this.addField = addField;
      return addField;
    },
    yulan() {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          if (this.reqCreate.yphone == null || this.reqCreate.yphone == '' || this.reqCreate.yphone.length != 11) {
            this.$message.error('请输入联系电话，或输入正确的电话号码（已方）');
            return false;
          }

          if (this.reqCreate.jbPhone != null && this.reqCreate.jbPhone != '' && this.reqCreate.jbPhone.length != 11) {
            this.$message.error('请输入正确的(乙方举报方式)联系电话');
            return false;
          }

          let temFields = this.fillTemplate();
          this.reqCreate.tempSignData = temFields;

          let reqData = {
            // cityId: this.reqCreate.cityId,
            fraId: this.reqCreate.fraId,
            eventType: 208,
            name: '收纳服务商协议',
            simpleFormFields: temFields
          };

          const loading = this.$loading({
            lock: true,
            text: '努力生成中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
          });
          console.log(reqData)
          contract
            .$ajaxPreviewFile(reqData)
            .then((res) => {
              if (res.data.errno == 0) {
                loading.close();
                // console.log(res);
                this.contractUrl = res.data.data.downloadUrl;
                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                this.PDFVisible = true;
              } else {
                loading.close();
                this.$message({
                  showClose: true,
                  message: res.data.data,
                  type: 'warning',
                  duration: 8000
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
    },
    sendContractBtn() {
      const loading = this.$loading({
        lock: true,
        text: '发送合同中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });

      this.reqCreate.fraId = globalData.franchisee.id;
      this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
      this.reqCreate.createUserName = globalData.userInfo.userName;
      this.reqCreate.type = 208;

      contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
        loading.close();
        if (res.data.errno == 0) {
          this.$message.success('合同已发送！');
          // this.querySearch();
          this.$emit('querySearch');
          this.PDFVisible = false;
          this.jcxy = false;
        } else {
          this.$message.warning(res.data.data);
        }
      });
    },
    getAllJMS() {
      //城市下拉框
      contract
        .$ajaxJmsgetJMSAll()
        .then((res) => {
          if (res.data.errno == 0) {
            this.allJMSList = res.data.data;
          }
        });
    },
  }
};
</script>
<style lang="">
.item .el-form-item__label{
    color:#f56c6c;
     font-weight:bold;
     font-size:10px
  }

  .nian .el-form-item__label{ 
     font-size:11px
  }
  
  .nian1 .el-form-item__label{ 
     font-size:10px
  }
</style>
